import { findPermissionTab } from "../../config/helpers";

const user = JSON.parse(localStorage.getItem("user"));
const isSupplier = user?.role === 1;

const options = [
  {
    key: "",
    path: "",
    label: "Dashboard",
    leftIcon: "fa fa-dashboard menu-icon",
    hasPermission: true,
  },
  {
    key: "analytics",
    path: "analytics",
    label: "Analytics",
    leftIcon: "fa fa-bar-chart menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "analytics/search-history",
    path: "analytics/search-history",
    label: "Search History",
    leftIcon: "fa fa-search menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "users",
    path: "users",
    label: "Users",
    leftIcon: "fa fa-users menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "sub-admins",
    path: "sub-admins",
    label: "Admins",
    leftIcon: "fa fa-user-circle menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "suppliers/pending",
    path: "suppliers",
    label: "Suppliers",
    leftIcon: "fa fa-drivers-license-o menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "listing/categories",
    path: "listing",
    label: "Listing",
    leftIcon: "fa fa-list-alt menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "supplier-products",
    path: "supplier-products",
    label: "Products",
    leftIcon: "fa fa-cube menu-icon",
    hasPermission: isSupplier,
  },
  {
    key: "product-groups",
    path: "product-groups",
    label: "Product Groups",
    leftIcon: "fa fa-object-group menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "insurance-companies",
    path: "insurance-companies",
    label: "Insurance Companies",
    leftIcon: "fa fa-building-o menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "selects",
    path: "selects",
    label: "Pillvery Selects",
    leftIcon: "fa fa-heart menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "orders/pending",
    path: "orders",
    label: "Orders",
    leftIcon: "fa fa-gift menu-icon",
    hasPermission: isSupplier || findPermissionTab(user?.privileges, "orders")?.actions?.view,
  },
  {
    key: "banners",
    path: "banners",
    label: "Banners",
    leftIcon: "fa fa-file-image-o menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "promotions/offers",
    path: "promotions",
    label: "Offers",
    leftIcon: "fa fa-tag menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "coupons",
    path: "coupons",
    label: "Coupons",
    leftIcon: "fa fa-ticket menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "blogs",
    path: "blogs",
    label: "Blogs",
    leftIcon: "fa fa-ticket menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "ratings/products",
    path: "ratings",
    label: "Ratings",
    leftIcon: "fa fa-star menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: isSupplier ? "notifications/notifications-history" : "notifications/push-notifications",
    path: "notifications",
    label: "Notifications Received",
    leftIcon: "fa fa-bell menu-icon",
    hasPermission: isSupplier || findPermissionTab(user?.privileges, "notifications")?.actions?.view,
  },
  {
    key: "payments",
    path: "payments",
    label: "Payment Gateway",
    leftIcon: "fa fa-credit-card menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "sms",
    path: "sms",
    label: "SMS Gateway",
    leftIcon: "fa fa-comment menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "accounting",
    path: "accounting",
    label: "Accounting",
    leftIcon: "fa fa-money menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "reports",
    path: "reports",
    label: "Reports",
    leftIcon: "fa fa-file menu-icon",
    hasPermission: !isSupplier,
  },
  {
    key: "settings/profile",
    path: "settings",
    label: "Profile Settings",
    leftIcon: "fa fa-cog menu-icon",
    hasPermission: isSupplier || findPermissionTab(user?.privileges, "settings")?.actions?.view,
  },
];

export default options;
